import { TripInvitation } from '~/models/TripInvitation'
import { InvitationService } from '~/services/trip/invitation/service'
import EventsService from '~/services/events'
import { TranslationService } from '~/services/Translation'
import { ItineraryService } from '~/passporter-services/itinerary/service'

export default class TripInvitationAction {
	public static async getInvitations(itineraryId: string): Promise<TripInvitation[]> {
		try {
			return await InvitationService.getInvitations(itineraryId)
		} catch {
			return []
		}
	}

	public static async inviteWithEmail(itineraryId: string, email: string): Promise<void> {
		const t = TranslationService.getInstance()
		try {
			await InvitationService.inviteWithEmail(itineraryId, email)
			EventsService.emitSuccess(t.translate('web.trip.invite.toast.send.success'))
		} catch (e: any) {
			if (e.data.code === 'traveler_already_in_trip') throw new Error('traveler_already_in_trip')
			EventsService.emitError(t.translate('web.trip.invite.toast.send.error'))
		}
	}

	public static async resendInvitation(itineraryId: string, email: string): Promise<void> {
		const t = TranslationService.getInstance()
		try {
			await InvitationService.inviteWithEmail(itineraryId, email)
			EventsService.emitSuccess(t.translate('web.trip.invite.toast.resend.success'))
		} catch {
			EventsService.emitError(t.translate('web.trip.invite.toast.resend.error'))
		}
	}

	public static async cancelInvitation(itineraryId: string, invitationId: string): Promise<void> {
		const t = TranslationService.getInstance()
		try {
			await InvitationService.cancelInvitation(itineraryId, invitationId)
			EventsService.emitSuccess(t.translate('web.trip.invite.toast.remove.success'))
		} catch {
			EventsService.emitError(t.translate('web.trip.invite.toast.remove.error'))
		}
	}

	static async deletePotentialTraveler(itineraryId: string): Promise<void> {
		const t = TranslationService.getInstance()
		try {
			await ItineraryService.deletePotentialTraveler(itineraryId)
			EventsService.emitSuccess(t.translate('web.trip.invite.toast.remove.success'))
		} catch {
			EventsService.emitError(t.translate('web.trip.invite.toast.remove.error'))
			throw Error('not_deleted')
		}
	}
}
